import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';

import css from './ModalMissingInformation.module.css';

const StripeAccountReminder = props => {
  const { className } = props;

  return (
    <div className={className}>
      <p className={css.modalTitle}>
        <FormattedMessage id="ModalMissingInformation.stripeAccountTitle" />
      </p>
      <p className={css.modalMessage}>
        <FormattedMessage id="ModalMissingInformation.stripeAccountText" />
      </p>

      <NamedLink className={css.reminderModalLinkButton} name="StripePayoutPage">
        <FormattedMessage id="ModalMissingInformation.stripeAccountLinkText" />
      </NamedLink>
    </div>
  );
};

export default StripeAccountReminder;
